
const DeviceGrid:React.FC<{children:React.ReactNode}> = ({children}) => {

    return(
        <> 
          <div className="row mt-4">
                <div className='row d-flex align-items-center device-row p-4'>
                   {children}
                </div>
            </div>
        </>
    )
}
export default DeviceGrid;